import { gold, textMuted } from '@/theme/colors'
import styled from 'styled-components'
import { text, leading } from '@/theme/typography'

/** Centered zero-state body: icon over a friendly line. Fills the tile body. */
export const EmptyBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 10px;
	padding: 20px 8px;
	color: ${textMuted};
`

export const EmptyIcon = styled.span`
	color: ${gold};
	display: inline-flex;

	svg {
		width: 48px;
		height: 48px;
	}
`

export const EmptyText = styled.p`
	${text.bodyXs}
	color: ${textMuted};
	margin: 0;
	max-width: 260px;
	line-height: ${leading.body};
`
